/**
 * @file Application header — the top bar of whichever frame is active.
 *
 * Shows the product mark and, when signed in, who you are and how to sign out. It deliberately does NOT
 * show the portfolio name: that lives in the sidebar, which is the persistent
 * answer to "where am I". Repeating it here would give two sources for the same
 * fact.
 *
 * Rendering nothing while the session is unresolved is deliberate — a visitor who
 * turns out to be signed in should never see a sign-out control flash.
 *
 * Full width, not a centred column: the header spans the frame, and the content
 * below it owns its own width.
 */
import { useAuthValue } from "../auth/context";

export function AppHeader() {
  const { session, UserMenu } = useAuthValue();

  return (
    <header className="border-b border-border bg-card">
      <div className="flex w-full items-center justify-between gap-3 px-4 py-2.5 sm:px-6 lg:px-8">
        <span className="flex items-center gap-2 text-sm font-semibold tracking-tight">
          NeighborOS
        </span>
        {session.isSignedIn ? <UserMenu /> : null}
      </div>
    </header>
  );
}
